import React from 'react';
import PropTypes from 'prop-types';
import {store} from '../App';
import {profileCustomerRequest, profileCustomerStats, profileCustomerStorage} from '../profile/actions/profile-actions';
import {checkIfCurrentAuthTokenIsExpired, checkTokenRedirect} from "../common/authorizationHelpers";
import {requestCartData} from "../cart/actions/cart-actions";
import {requestWebConfig} from "../settings/actions/customer-settings-actions";
import {requestOrderStatusData} from "../orderStatus/reducers/order-status-actions";

export class PrivateRoute extends React.Component {
    constructor() {
        super();
        this.state = {
            isTokenPresentAndValid: false
        };
    }

    async componentDidMount() {
        try {
            const isTokenPresentAndValid = await checkTokenRedirect(this.props.location);
            isTokenPresentAndValid && store.dispatch(requestWebConfig)
            isTokenPresentAndValid && store.dispatch(profileCustomerRequest);
            isTokenPresentAndValid && store.dispatch(requestCartData(store.dispatch))
            isTokenPresentAndValid && store.dispatch(profileCustomerStats)
            isTokenPresentAndValid && store.dispatch(profileCustomerStorage)
            isTokenPresentAndValid && requestOrderStatusData(store.dispatch)

            this.setState({isTokenPresentAndValid});
        } catch (err) {
            console.log(err);
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            const authTokenObject = JSON.parse(window.localStorage.getItem('authorizationState'));
            if (authTokenObject.expirationDate && checkIfCurrentAuthTokenIsExpired(authTokenObject.expirationDate)) {
                try {
                    const isTokenPresentAndValid = await checkTokenRedirect(this.props.location);
                    isTokenPresentAndValid && store.dispatch(profileCustomerRequest);
                    isTokenPresentAndValid && store.dispatch(requestCartData(store.dispatch))
                    this.setState({isTokenPresentAndValid});
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }

    render() {
        const {isTokenPresentAndValid} = this.state;
        return isTokenPresentAndValid ?
            this.props.children :
            null;
    }
}

PrivateRoute.propTypes = {
    location: PropTypes.object
};


// WEBPACK FOOTER //
// ./src/routes/private-route.jsx